'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_3ddbb815 = {"container":"Filter_module_container__74477a37","icon":"Filter_module_icon__74477a37","filtered":"Filter_module_filtered__74477a37"};
require("../../../assets/cjs/components/Table/src/Filter~B8oQSTcQ.css");

exports.default = modules_3ddbb815;
//# sourceMappingURL=Filter.module.less.js.map
